// extracted by mini-css-extract-plugin
module.exports = {"component":"ui-loader_component__LW06A","local":"ui-loader_local__gm0q5","global":"ui-loader_global__vuWOR"};